import { Component, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonDataService } from '@shared/services/common-data.service';
import { Auth } from 'aws-amplify';

import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { custom } from 'devextreme/ui/dialog';
import { AuthService } from '@modules/auth/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {

  

  idleState = 'NOT_STARTED';
  timedOut = false;
  idleEndCount = 0;
  idleStartCount = 0;
  idleTimeoutCount = 0;
  countdown:any;
  idleTimeoutWarningCount = 0;
  lastPing?: Date;
  constructor( private authService: AuthService, private commonSer: CommonDataService, private router: Router, private idle: Idle,
    private zone: NgZone){
      Auth.currentAuthenticatedUser().then(() => {
        

        this.commonSer.createAuthorizationToken().subscribe(r=>{
          if(r.status=="SUCCESS"){
            this.commonSer.getUser().subscribe(r => {
                if(r.status=="SUCCESS" && r.serviceResult.activeFlag && !window.location.pathname.includes('downloadUid')){
                if(window.location.pathname.slice(0,13)!='/preview-pdf/'){
                    commonSer.fetchAllCommonData();            
                }
                

                
          this.idle.setIdle(3600);
          // this.idle.setTimeout(5 * 60);
          this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
          
          idle.onIdleEnd.subscribe(() => {
            this.idleEndCount++;
            this.idleState = 'No longer idle.'
          });
          
           idle.onTimeout.subscribe(() => {
            this.idleTimeoutCount++;
            this.idleState = 'Timed out!';
          });
          
          idle.onIdleStart.subscribe(() => {
            this.idleStartCount++;
            this.idleState = 'You\'ve gone idle!';
            this.timedOut = true;
            this.authService.logout();
          });
          
          idle.onTimeoutWarning.subscribe((countdown) => {
            this.idleTimeoutWarningCount++;
            this.countdown = countdown;
            this.idleState = 'You will time out in ' + countdown + ' seconds!';
          });


          idle.onInterrupt.subscribe(() => {
              this.commonSer.idleCookieSet();
          });

    //       keepalive.interval(15);

    // keepalive.onPing.subscribe(() => this.lastPing = new Date());
          
           this.reset();

              }
              
            })
          }
        })
      })
      .catch(() => {
      }); 
    } 


  
    

  
    reset() {
      this.idle.watch();
      this.idleState = 'Started.';
      this.timedOut = false;
    }
    
  customAlert(message: any){
    const mpDialog = custom({
      showTitle: false,
      messageHtml: message,
      buttons: [
        
        {
          text: "Stay Signed In",
          onClick: (e) => {
            mpDialog.hide();
            this.reset();
          }
        },
        {
          text: "Sign Out",
          onClick: (e) => {
            this.authService.logout();
          //   window.localStorage.removeItem("mp-serve-auth");
          // window.localStorage.removeItem("mpuserdetailslock");
          // window.localStorage.removeItem("mpUInfo");
          // window.localStorage.removeItem('cookieDetails');
          // window.localStorage.removeItem('cookieStartTimer');
          // window.localStorage.removeItem('cookieEndTimer');
          //   Auth.signOut();
          }
        }
      ]
  });
  mpDialog.show();
  }

}
